import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.8 19.2h2.4v-2.4h-2.4zM12 0C5.376 0 0 5.376 0 12s5.376 12 12 12 12-5.376 12-12S18.624 0 12 0m0 21.6c-5.292 0-9.6-4.308-9.6-9.6S6.708 2.4 12 2.4s9.6 4.308 9.6 9.6-4.308 9.6-9.6 9.6m0-16.8a4.8 4.8 0 0 0-4.8 4.8h2.4c0-1.32 1.08-2.4 2.4-2.4s2.4 1.08 2.4 2.4c0 2.4-3.6 2.1-3.6 6h2.4c0-2.7 3.6-3 3.6-6 0-2.652-2.148-4.8-4.8-4.8"
    }, null, -1)
  ]))]))
}
export default { render: render }